import React, { Component } from 'react';

const getDate = () => {
    let _data = new Date();
    return `${ _data.getDate() }/${ _data.getMonth() + 1 }/${ _data.getFullYear() }`;
}

const data = [
    {
        avaliacao: "Muito bom! Ótimo para revenda e entrega para clientes finais.",
        nome: "João Augusto",
        data: getDate()
    },
    {
        avaliacao: "Gostei muito, uso sempre no dia a dia. Interessante ver o uso com 3 saídas",
        nome: "Carlos Alencar",
        data: getDate()
    },
    {
        avaliacao: "Entrega super rápida, muito bem embalado, comprei para revender e veio bem cuidado.",
        nome: "Marcos Silveira",
        data: getDate()
    },
    {
        avaliacao: "Comprei com o João na Segunda, na Sexta já estava em casa. Muito rápido. Comprar na caixa em quantidade mantém mais qualidade.",
        nome: "Marlon",
        data: getDate()
    }
]

export default class Avaliacoes extends Component {
    render(){
        return (
            <div className="Avaliacoes">
                <div className="container flex vertical">
                    <h2 className="text-center">Avaliações</h2>
                    <div className="flex horizontal wrap">

                        {
                            data.map((_item, idx) => (
                                <div className="flex-1 flex-basis-40 flex flex-center">

                                    <div className="panel">
                                        <div className="panel-message">
                                            { _item.avaliacao }
                                        </div>
                                        <div className="panel-base flex horizontal ">
                                            <div className="panel-nome">
                                                { _item.nome } - { _item.data }
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            ))
                        }

                    </div>
                </div>
            </div>
        )
    }
}